import { MapContainer, TileLayer, Marker } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Leaflet's own marker images don't survive the bundler, so the pin is drawn
// in CSS — the same red pin the rest of the site uses.
const pin = L.divIcon({
  className: "",
  html: `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="#ef4444" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"/><circle cx="12" cy="10" r="3"/></svg>`,
  iconSize: [30, 30],
  iconAnchor: [15, 30],
});

// A map of the shop that customers can drag and zoom, on OpenStreetMap tiles.
export default function ShopMap({ latitude, longitude, zoom = 15, className = "" }) {
  const position = [Number(latitude), Number(longitude)];

  return (
    <MapContainer
      center={position}
      zoom={zoom}
      // Scrolling the page shouldn't zoom the map; dragging and the buttons still do.
      scrollWheelZoom={false}
      className={`z-0 h-full w-full ${className}`}
      aria-label="Map"
    >
      <TileLayer
        url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        maxZoom={19}
      />
      <Marker position={position} icon={pin} />
    </MapContainer>
  );
}

/** Opens directions to the shop in Google Maps (the app on phones). */
export function directionsUrl(latitude, longitude) {
  return `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;
}
